import { NotebookActionKey } from "../../../actions/ActionKeys";
import { NotebookAction } from "../../../actions/notebook";

export const kernelIdPath = (
  state: string | null = null,
  action: NotebookAction
): string | null => {
  switch (action.type) {
    case NotebookActionKey.SET_KERNEL_SPEC:
      return action.payload.kernelIdPath;
    case NotebookActionKey.SET_KERNEL_ID_PATH:
      return action.payload.kernelIdPath;
    default:
      return state;
  }
};
